import {
  Component,
  OnDestroy,
  OnInit,
  input,
  output,
  viewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import { AdminType, User } from "../users.model";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "app-admins-list",
    templateUrl: "./admins-list.component.html",
    styleUrls: ["./admins-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminsListComponent implements OnInit, OnDestroy {
  readonly admins$ = input<Observable<User[]>>(undefined);
  readonly adminType = input<AdminType>(undefined);
  readonly adminSelected = output<User>();

  readonly sort = viewChild(MatSort);
  displayedColumns = ["name", "phone", "email"];
  dataSource: MatTableDataSource<User>;
  selectedRowIndex: number;

  private destroyed$ = new Subject();

  get admType() {
    return AdminType;
  }

  constructor() {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    const adminType = this.adminType();
    if (adminType === AdminType.BranchAdmin) {
      this.displayedColumns = [...this.displayedColumns, "branch"];
    } else if (adminType === AdminType.ChainAdmin) {
      this.displayedColumns = [...this.displayedColumns, "chain"];
    }
    this.admins$().pipe(takeUntil(this.destroyed$)).subscribe((adm) => {
      this.dataSource.data = adm;
      this.dataSource.sort = this.sort();
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  selectServiceman(admin: User, i: number) {
    this.selectedRowIndex = i;
    this.adminSelected.emit(admin);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(1);
    this.destroyed$.complete();
  }
}
